import { create } from "zustand";

type ApiMode = "local" | "global";

type ApiModeState = {
  apiMode: ApiMode;
  setApiMode: (mode: ApiMode) => void;
};

const storedApiMode = typeof window !== 'undefined' ? (localStorage.getItem('apiMode') as ApiMode) : null;

export const useApiModeStore = create<ApiModeState>((set) => ({
  apiMode: storedApiMode ?? 'local',
  setApiMode: (mode) => {
    localStorage.setItem('apiMode', mode);
    set({ apiMode: mode });
  },
}));